import { CloseOutlined, ReloadOutlined } from "@ant-design/icons"
import { Button, Flex, Typography } from "antd"
import { useState } from "react"

import { useNewVersionAvailable } from "../../hooks/use-new-version-available.ts"

const { Text } = Typography

// App-level infrastructure, like ErrorElement.tsx and the chunk-load notice —
// deliberately outside i18n so it never depends on the very bundle it exists
// to tell the user is out of date.
export function NewVersionBanner() {
  const available = useNewVersionAvailable()
  const [dismissed, setDismissed] = useState(false)

  if (!available || dismissed) return null

  return (
    <Flex
      align={"center"}
      gap={12}
      data-testid={"new-version-banner"}
      className={
        "fixed bottom-4 right-4 z-[2000] rounded-lg bg-gray-900 px-4 py-3 shadow-lg"
      }
    >
      <Text className={"text-sm text-white"}>A new version is available.</Text>
      <Button
        size={"small"}
        type={"primary"}
        icon={<ReloadOutlined />}
        onClick={() => window.location.reload()}
      >
        Reload
      </Button>
      <Button
        size={"small"}
        type={"text"}
        aria-label={"Dismiss"}
        icon={<CloseOutlined className={"text-white"} />}
        onClick={() => setDismissed(true)}
      />
    </Flex>
  )
}
